import Vue from "vue";
import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);

// <-- css -->
import '@/config/vue2-editor/vue2-editor.scss';
